/**
 *  ReadMore
 *  Adds a readmore button to the content of the element with the class {selector_content}
 *
 *  v1.1 - 26.01.30
 *       - make it work for multiple instances on the same page
 *  v1.0 - 26.01.30
 *       - initial version (adapted from previous code)
 *
 */
import LeStickyIt from "../stickit/le-stick_it.js";

class LeReadMore {

    constructor( config ) {

        const settings_default = {
            wrapper_selector : '.kn-readmore-wrapper',
            content_selector : '.kn-readmore-content',
            container_selector : '.kn-readmore-container',
            button_selector : '.kn-readmore-button',
            parent_min_height: 400,
            debug: false
        }

        this.settings = {
            ...settings_default,
            ...config
        }
        this.settings.button_selector_full = this.settings.wrapper_selector + ' ' + this.settings.button_selector;

        this._log('constructor( config ) > config = ', config );

    }

    init() {
        this._log('init()');

        const parent_elements = document.querySelectorAll( this.settings.wrapper_selector );
        if ( parent_elements.length ) {

            parent_elements.forEach( (parent_ele, ind) => {
                this._log('init() > parent_ele = ', parent_ele);

                const button_element = parent_ele.querySelector(this.settings.button_selector);
                const parent_height = parent_ele.clientHeight;

                this._log('init() > button_element (selector = ' + this.settings.button_selector + ' ) = ', button_element);

                if (parent_height <= (this.settings.parent_min_height + 20)) {
                    this._log('parent too small, no button needed ( parent_min = ' + this.settings.parent_min_height + ' ), hiding button');

                    if (button_element.target) {
                        button_element.target.parentNode.classList.toggle('-open');
                    }
                } else {
                    this._log('parent big enough ( parent_min = ' + this.settings.parent_min_height + ' ) setting up event listener for button');
                    parent_ele.classList.add('-initted');
                    if (button_element != null) {
                        button_element.classList.remove('hidden');
                        button_element.addEventListener('click', (ev) => {
                            this._log('button clicked', ev.target);

                            const wrapper = ev.target.closest(this.settings.wrapper_selector);
                            const container = wrapper.querySelector(this.settings.container_selector);
                            const content = container.querySelector(this.settings.content_selector);
                            const content_height = content.clientHeight;

                            console.log(container, content, content_height);

                            ev.target.classList.toggle('hidden');
                            ev.target.parentNode.classList.toggle('-open');
                            container.classList.toggle('-open');
                            container.style.maxHeight = (content_height + 20) + 'px';
                        })
                    } else {
                        this._log('No button found, can\'t initialize, stopping.');
                    }
                }
            });
        };

    }

    _log() {
        if (this.settings.debug) {
            console.log('LeReadMore: ', ...arguments);
            // console.log("This is a %cbold%c word", "font-weight: bold;", "");
            // console.log("%LeReadMore > %c ", "font-weight: bold;", "", ...arguments);
        }
    }

}


export default LeReadMore;
